














































































































































































































































































































































































































































































































































































































































































































































































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";
import _, { parseInt } from "lodash";
import MyForm from "@/mixins/form";

import Equipment from "./equipment.vue";
import Manager from "./components/manager.vue";
import OnlineStatus from "./components/onlinestatus.vue";
import ActiveTaisamRobot from "./components/active_taisam_robot.vue";
import StadiumTypeSetting from "./components/stadium_type_setting.vue";
import AllowUpgrade from "./components/allowupgrade.vue";
import SmsSign from "./components/smssign.vue";
import Remark from "./components/remark.vue";

@Component({
  components: {
    Manager,
    Equipment,
    OnlineStatus,
    AllowUpgrade,
    SmsSign,
    ActiveTaisamRobot,
    StadiumTypeSetting,
    Remark
  }
})
export default class extends Mixins(MyForm) {
  @Prop() stadiumId!: number;

  @Prop() customerId!: number;

  @Prop() online_read_time!: string;

  @Prop() is_internal!: boolean;

  @Prop() is_wechat_stadium!: boolean;

  @Prop() updateOnlineReadTime!: Function;

  isWechatStadium = "0";

  equipModalVisible = false;

  bookingCountForm!:any;
  bookingCountModal=false;
  bookingDaysForm!:any;
  bookingDaysModal=false;

  priceModal = false;

  depositModal = false;
  depositStatus=-1;

  timeLimitModal = false;

  freeTimeModal = false;

  priceForm!: any;
  depositForm!:any;

  timeLimitForm!: any;
  freeTimeForm!: any;

  crmAttencePercentForm!: any;
  crmAttencePercentModal = false;

  crmAttenceLogCountForm!: any;
  crmAttenceLogCountModal = false;

  is_control_gate = false;

  is_control_updown = false;

  is_manual_bill = false;

  is_only_taisam = false;

  is_control_ground_lights = false;

  is_control_more_long_open = false;

  is_has_reduction = false;

  is_half_time = false;

  is_disable_ai = false;

  is_disable_supercard = false;

  is_disable_ai_redpacket = false;

  is_enable_ai_perception = false;

  is_disable_now_bill = false;

  is_disable_wechatbill_notice = false;

  is_auto_open = false;

  is_auto_disable_vipcard = false;

  is_auto_wechatbill_receive = false;

  is_enable_manager_dmarketing = false;

  is_enable_all_open = false;

  is_enable_action_recognition = false;

  is_enable_training = false;

  is_add_send_sms = false;

  is_import_vip = false;

  is_setting_vip = false;

  is_unlimit_open = false;

  is_block_charge = false;

  is_must_choose_player = false;

  is_disable_lock = false;

  is_year_devops=false;
  is_auto_booking=false;

  player_booking_count='0';
  player_booking_days='0';
  player_booking_unit='0';

  crm_attence = false;

  managerUserId = 0;

  is_edit_vip = false;

  deposit={
    status:-1,
    desc:'',
  }

  renderIsWechatStadium() {
    return this.is_wechat_stadium ? "1" : 0;
  }

  changeVersion(e: any) {
    // console.log(e);
    this.showTsConfirm({
      title: "确认信息",
      content: "你确定要修改场馆版本吗？",
      onOk: async () => {
        this.isWechatStadium = e.target.value;
        const res = await this.$store.dispatch("stadium/changeVersion", {
          stadium_id: this.stadiumId,
          type: e.target.value
        });
        if (res && res.Message && String(res.Message) === "success") {
          this.$message.success(res.Message);
        } else {
          this.$message.error(res.Message);
        }
      },
      onCancel: () => {
        this.isWechatStadium = String(e.target.value) === "1" ? "0" : "1";
      }
    });
  }

  logout() {
    // console.log(this.formData);
    this.showTsConfirm({
      title: "确认信息",
      content: "你确定要踢出吗？",
      onOk: async () => {
        const res = await this.$store.dispatch("stadium/managerlogout", {
          user_id: this.managerUserId
        });
        if (res && res.Message && res.Message === "success") {
          this.$message.success(res.Message);
        } else {
          this.$message.error(res.Message);
        }
      }
    });
  }

  beforeCreate() {
    this.priceForm = this.$form.createForm(this);
    this.timeLimitForm = this.$form.createForm(this);
    this.freeTimeForm = this.$form.createForm(this);
    this.crmAttencePercentForm = this.$form.createForm(this);
    this.crmAttenceLogCountForm = this.$form.createForm(this);
    this.depositForm = this.$form.createForm(this);
    this.bookingCountForm = this.$form.createForm(this);
    this.bookingDaysForm = this.$form.createForm(this);
  }

  showEquipModal() {
    this.equipModalVisible = true;
  }

  hideEquipModal() {
    this.equipModalVisible = false;
  }

  showTimeLimitModal() {
    this.timeLimitModal = true;
  }

  hideTimeLimitModal() {
    this.timeLimitModal = false;
  }

  showFreeTimeModal() {
    this.freeTimeModal = true;
  }

  hideFreeTimeModal() {
    this.freeTimeModal = false;
  }

  showPriceModal() {
    this.priceModal = true;
  }

  hidePriceModal() {
    this.priceModal = false;
  }

  showDepositModal(){
    this.depositModal = true;
  }

  showBookingCountModal(){
    this.bookingCountModal=true;
  }

  showBookingDaysModal(){
    this.bookingDaysModal=true;
  }

  hideDepositModal() {
    this.depositModal = false;
  }

  hideBookingCountModal(){
    this.bookingCountModal=false;
  }

  hideBookingDaysModal(){
    this.bookingDaysModal=false;
  }

  showCrmAttencePercentModal() {
    this.crmAttencePercentModal = true;
  }

  hideCrmAttencePercentModal() {
    this.crmAttencePercentModal = false;
  }

  showCrmAttenceLogCountModal() {
    this.crmAttenceLogCountModal = true;
  }

  hideCrmAttenceLogCountModal() {
    this.crmAttenceLogCountModal = false;
  }

  validateNumber(rule: any, value: any, callback: any) {
    const form = this.timeLimitForm;
    if (value) {
      if (Number(value) < 5) {
        callback("值不能小于5");
      }
    }
    callback();
  }

  handlePriceSubmit() {
    this.priceForm.validateFields((err: any, fieldsValue: any) => {
      if (!err) {
        // console.log(fieldsValue);
        this.showTsConfirm({
          title: "确认信息",
          content: "确定要提交吗？",
          onOk: async () => {
            const fieldname = "stadium_manage_fee";
            const res = await this.$store.dispatch("stadium/settingChange", {
              stadium_id: this.stadiumId,
              fieldname,
              fieldval: this.tsMul(fieldsValue.money, 100),
              content: "修改管理系统价格"
            });
            if (res && res.Message && res.Message === "success") {
              _.set(this.formData, [fieldname], this.tsMul(fieldsValue.money, 100));
              this.hidePriceModal();
              this.$message.success("操作成功");
            } else {
              this.$message.error(res.Message);
            }
          }
        });
      }
    });
  }

  handleDepositSubmit() {
    this.depositForm.validateFields((err: any, fieldsValue: any) => {
      if (!err) {
        // console.log(fieldsValue);
        this.showTsConfirm({
          title: "确认信息",
          content: "确定要提交吗？",
          onOk: async () => {
            const fieldname = "stadium_deposit_fee";
            const res = await this.$store.dispatch("stadium/settingChange", {
              stadium_id: this.stadiumId,
              fieldname,
              fieldval: this.tsMul(fieldsValue.money, 100),
              content: "修改智能工作站押金"
            });
            if (res && res.Message && res.Message === "success") {
              _.set(this.formData, [fieldname], this.tsMul(fieldsValue.money, 100));
              this.hideDepositModal();
              this.$message.success("操作成功");
            } else {
              this.$message.error(res.Message);
            }
          }
        });
      }
    });
  }

  handleTimeLimitSubmit() {
    this.timeLimitForm.validateFields((err: any, fieldsValue: any) => {
      if (!err) {
        this.showTsConfirm({
          title: "确认信息",
          content: "确定要提交吗？",
          onOk: async () => {
            const fieldname = "cancel_bill_time_limit";
            const res = await this.$store.dispatch("stadium/settingChange", {
              stadium_id: this.stadiumId,
              fieldname,
              fieldval: fieldsValue.time,
              content: "修改取消订单时限"
            });
            if (res && res.Message && res.Message === "success") {
              Vue.set(this.formData, fieldname, fieldsValue.time);
              this.hideTimeLimitModal();
              this.$message.success("操作成功");
            } else {
              this.$message.error(res.Message);
            }
          }
        });
      }
    });
  }

  handleFreeTimeSubmit() {
    this.freeTimeForm.validateFields((err: any, fieldsValue: any) => {
      if (!err) {
        this.showTsConfirm({
          title: "确认信息",
          content: "确定要提交吗？",
          onOk: async () => {
            const fieldname = "free_bill_time_limit";
            const res = await this.$store.dispatch("stadium/settingChange", {
              stadium_id: this.stadiumId,
              fieldname,
              fieldval: fieldsValue.time,
              content: "修改订单免费时限"
            });
            if (res && res.Message && res.Message === "success") {
              Vue.set(this.formData, fieldname, fieldsValue.time);
              this.hideFreeTimeModal();
              this.$message.success("操作成功");
            } else {
              this.$message.error(res.Message);
            }
          }
        });
      }
    });
  }

  handleCrmAttencePercentSubmit() {
    this.crmAttencePercentForm.validateFields((err: any, fieldsValue: any) => {
      if (!err) {
        this.showTsConfirm({
          title: "确认信息",
          content: "确定要提交吗？",
          onOk: async () => {
            const fieldname = "crm_attence_percent";
            const res = await this.$store.dispatch("stadium/settingChange", {
              stadium_id: this.stadiumId,
              fieldname,
              fieldval: fieldsValue[fieldname],
              content: "考勤状态判断"
            });
            if (res && res.Message && res.Message === "success") {
              this.$set(this.formData, fieldname, fieldsValue[fieldname]);
              this.hideCrmAttencePercentModal();
              this.$message.success("操作成功");
            } else {
              this.$message.error(res.Message);
            }
          }
        });
      }
    });
  }

  handleCrmAttenceLogCountSubmit() {
    this.crmAttenceLogCountForm.validateFields((err: any, fieldsValue: any) => {
      if (!err) {
        this.showTsConfirm({
          title: "确认信息",
          content: "确定要提交吗？",
          onOk: async () => {
            const fieldname = "crm_attence_log_count";
            const res = await this.$store.dispatch("stadium/settingChange", {
              stadium_id: this.stadiumId,
              fieldname,
              fieldval: fieldsValue[fieldname],
              content: "考勤无人值守判断次数"
            });
            if (res && res.Message && res.Message === "success") {
              Vue.set(this.formData, fieldname, fieldsValue[fieldname]);
              this.hideCrmAttenceLogCountModal();
              this.$message.success("操作成功");
            } else {
              this.$message.error(res.Message);
            }
          }
        });
      }
    });
  }

  async mounted() {
    this.isWechatStadium = this.is_wechat_stadium ? "1" : "0";

    const res1 = await this.$store.dispatch("enterapply/detail", {
      stadium_id: this.stadiumId
    });
    if (res1 && res1.Data && res1.Data.manager) {
      this.managerUserId = res1.Data.manager.user_id;
      this.deposit.status=parseInt(res1.Data.is_deposit_reject || '-1');
      this.deposit.desc = res1.Data.deposit_reason || '';
      this.depositStatus=this.deposit.status;
    }
    // console.log("updateOnlineReadTime", this.updateOnlineReadTime);
    await this.refreshConfig()
  }

  async refreshConfig() {
    const res = await this.$store.dispatch("stadium/settingDetail", {
      stadium_id: this.stadiumId
    });
    if (res && res.Data) {
      this.formData = res.Data;
      this.is_control_gate = res.Data.is_control_gate === "1";
      this.is_control_updown = res.Data.is_control_updown === "1";
      this.is_manual_bill = res.Data.is_manual_bill === "1";
      this.is_only_taisam = res.Data.is_only_taisam === "1";
      this.is_control_ground_lights = res.Data.is_control_ground_lights === "1";
      this.is_control_more_long_open = res.Data.is_control_more_long_open === "1";
      this.is_has_reduction = res.Data.is_has_reduction === "1";
      this.is_half_time = res.Data.is_half_time === "1";
      this.is_disable_ai = res.Data.is_disable_ai === "0";
      this.is_disable_supercard = res.Data.is_disable_supercard === "0";
      this.is_disable_ai_redpacket = res.Data.is_disable_ai_redpacket === "0";
      this.is_enable_ai_perception = res.Data.is_enable_ai_perception === "1";
      this.is_disable_now_bill = res.Data.is_disable_now_bill === "0";
      this.is_disable_wechatbill_notice = res.Data.is_disable_wechatbill_notice === "0";
      this.is_auto_open = res.Data.is_auto_open === "1";
      this.is_auto_disable_vipcard = res.Data.is_auto_disable_vipcard === "1";
      this.is_auto_wechatbill_receive = String(res.Data.is_auto_wechatbill_receive) === "1";
      this.is_enable_manager_dmarketing = res.Data.is_enable_manager_dmarketing === "1";
      this.is_enable_all_open = res.Data.is_enable_all_open === "1";
      this.is_enable_action_recognition = res.Data.is_enable_action_recognition === "1";
      this.is_enable_training = res.Data.is_enable_training === "1";
      this.is_must_choose_player = res.Data.is_must_choose_player === "1";
      this.is_add_send_sms = res.Data.is_add_send_sms === "1";
      this.is_import_vip = res.Data.is_import_vip === "1";
      this.is_setting_vip = res.Data.is_setting_vip === "1";
      this.is_unlimit_open = res.Data.is_unlimit_open === "1";
      this.is_block_charge = res.Data.is_block_charge === "1";
      this.is_disable_lock = res.Data.is_disable_lock === "1";
      this.crm_attence = res.Data.crm_attence === "1";
      this.is_year_devops = res.Data.is_year_devops === "1";
      this.is_edit_vip = res.Data.is_edit_vip === "1";
      this.is_auto_booking = res.Data.is_auto_booking === "1";
      this.player_booking_count = res.Data.player_booking_count;
      this.player_booking_unit = res.Data.player_booking_unit;
      this.player_booking_days = res.Data.player_booking_days;
    }
  }

  changeSettingStatus(fieldname: string, fieldval: string, fieldval1: string, content: string) {
    let status = "";
    // console.log(fieldval);
    if (fieldval) {
      status = "开启";
    } else {
      status = "关闭";
    }
    status += content;

    if (fieldname == "is_enable_action_recognition") {
      if (this.stadiumId != 3088) {
        this.$message.error("行为识别硬件未部署，无法开启行为识别功能。");
        return;
      }
    }

    this.showTsConfirm({
      title: "确认信息",
      content: `确认要${status}吗？`,
      onOk: async () => {
        const res = await this.$store.dispatch("stadium/settingChange", {
          stadium_id: this.stadiumId,
          fieldname,
          fieldval,
          content: status
        });
        if (res && res.Message && res.Message === "success") {
          _.set(this, fieldname, fieldval1);
          this.$message.success("操作成功");
          if(fieldname=="is_add_send_sms" && fieldval){
            let target=this;
            setTimeout(function(){
            target.showTsConfirm({
              title:"短信提醒",
              content:"可能存在之前未发送的短信，您现在是否要发送？",
              onOk: async () => {
                const res = await target.$store.dispatch("sms/sendPending", {
                  stadium_id: target.stadiumId
                });
                if (res && res.Message && res.Message === "success") {
                  target.$message.success("操作成功");
                } else {
                  target.$message.error(res.Message);
                }
              }
            })},1000);
          }
        } else {
          this.$message.error(res.Message);
        }
      }
    });
  }

  installComplete() {
    this.showTsConfirm({
      title: "确认信息",
      content: "你确定要点击安装完成吗？",
      onOk: async () => {
        const res = await this.$store.dispatch("enterapply/installComplete", {
          stadium_id: this.stadiumId
        });

        if (res && res.Message && res.Message === "success") {
          this.$message.success("操作成功");
        } else {
          this.$message.error(res.Message);
        }
      }
    });
  }

  changeDeposit() {
    this.showTsConfirm({
      title: "确认信息",
      content: "你确定押金已退还吗？",
      onOk: async () => {
        const res = await this.$store.dispatch("robots/reject", {
          stadium_id: this.stadiumId,
          status:this.deposit.status,
        });
        if (res && res.Message && res.Message === "success") {
          this.$message.success("操作成功");
          this.deposit.desc=res.Data;
          this.depositStatus=this.deposit.status;
        } else {
          this.$message.error(res.Message);
          this.deposit.status=this.depositStatus;
        }
      },
      onCancel: async () => {
        this.deposit.status=this.depositStatus;
      }
    });
  }

  handleBookingCountSubmit(){
    this.bookingCountForm.validateFields((err: any, fieldsValue: any) => {
      if (!err) {
        this.hideBookingCountModal();
        this.showTsConfirm({
          title: "确认信息",
          content: `确认要更新吗？`,
          onOk: async () => {
            const res = await this.$store.dispatch("stadium/settingChange", {
              stadium_id: this.stadiumId,
              fieldname:'player_booking_unit',
              fieldval:fieldsValue.cate,
              content: '订场次数'
            });
            if (res && res.Message && res.Message === "success") {
              _.set(this, 'player_booking_unit', fieldsValue.cate);
              await this.$store.dispatch("stadium/settingChange", {
                stadium_id: this.stadiumId,
                fieldname:'player_booking_count',
                fieldval:fieldsValue.count,
                content: '订场次数'
              });
              _.set(this, 'player_booking_count', fieldsValue.count);
              this.$message.success("操作成功");
            } else {
              this.$message.error(res.Message);
            }
          }
        });
      }
    });
  }

  handleBookingDaysSubmit(){
    this.bookingDaysForm.validateFields((err: any, fieldsValue: any) => {
      if (!err) {
        this.hideBookingDaysModal();
        this.showTsConfirm({
          title: "确认信息",
          content: `确认要更新吗？`,
          onOk: async () => {
            const res = await this.$store.dispatch("stadium/settingChange", {
              stadium_id: this.stadiumId,
              fieldname:'player_booking_days',
              fieldval:fieldsValue.days,
              content: '订场天数'
            });
            if (res && res.Message && res.Message === "success") {
              _.set(this, 'player_booking_days', fieldsValue.days);
              this.$message.success("操作成功");
            } else {
              this.$message.error(res.Message);
            }
          }
        });
      }
    });
  }

}
